import { useState } from "react";
import { Download, FileText } from "lucide-react";
import { MANUAL } from "@/lib/manual";
import { buildManualPdf as buildPdf } from "@/lib/manualPdf";
import { useI18n } from "@/lib/i18n";
import { GoldButton } from "@/components/Brand";

export default function AdminManual() {
  const { t, lang } = useI18n();
  const [open, setOpen] = useState(null);
  const m = MANUAL[lang] || MANUAL.es;

  return (
    <div className="space-y-6" data-testid="admin-manual">
      <div className="flex flex-wrap items-center justify-between gap-4">
        <div>
          <h2 className="font-serif-display text-3xl text-[#8F3329]">{m.title}</h2>
          <p className="mt-1 text-sm text-[#5A5752]">{m.subtitle}</p>
        </div>
        <div className="flex flex-wrap gap-3">
          <GoldButton
            data-testid="manual-download-pdf"
            onClick={() => buildPdf(m).save(lang === "en" ? "HR-Creations-User-Manual.pdf" : "HR-Creations-Manual-de-Usuario.pdf")}
          >
            <Download size={14} /> {t("manual.pdf")}
          </GoldButton>
          <button
            type="button"
            data-testid="manual-print"
            onClick={() => buildPdf(m).output("dataurlnewwindow")}
            className="inline-flex min-h-[44px] items-center gap-2 border border-[#C69A3B] px-5 text-xs text-[#8F3329]"
          >
            <FileText size={14} /> {t("manual.view")}
          </button>
        </div>
      </div>

      <p className="max-w-3xl text-sm text-[#5A5752]" data-testid="manual-intro">{m.intro}</p>

      <div className="space-y-3" data-testid="manual-sections">
        {m.sections.map((sec) => {
          const on = open === sec.id;
          return (
            <div key={sec.id} className="border border-[#C69A3B]/40 bg-white">
              <button
                type="button"
                data-testid={`manual-section-${sec.id}`}
                onClick={() => setOpen(on ? null : sec.id)}
                className={`flex min-h-[52px] w-full items-center justify-between gap-4 px-5 text-left text-sm transition-colors duration-300 ${
                  on ? "bg-[#8F3329] text-[#FAFAF7]" : "text-[#8F3329] hover:bg-[#C69A3B]/10"
                }`}
              >
                <span className="font-serif-display text-lg">{sec.title}</span>
                <span className="label-mono">{on ? "−" : "+"}</span>
              </button>
              {on && (
                <ul className="space-y-3 px-6 py-5" data-testid={`manual-steps-${sec.id}`}>
                  {sec.steps.map((step, i) => (
                    <li key={i} className="flex gap-3 text-sm text-[#5A5752]">
                      <span className="label-mono text-[#C69A3B]">{String(i + 1).padStart(2, "0")}</span>
                      <span>{step}</span>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
